import React, {useState} from "react";
import axios from "axios";
import "./PopupLogin.css";
import herb from "./herb.png";
import {useNavigate} from "react-router-dom";
import {useRef} from "react";
import ConditionPopup from "../conditionPopup/ConditionPopup";
import {useFormik} from 'formik';
import * as yup from 'yup';
import {IoArrowBackSharp} from "react-icons/io5";
import {AiFillEye, AiFillEyeInvisible} from "react-icons/ai";
import CustomAlert from "../ConfirmationModal/CustomAlert";
import {useLocation} from 'react-router-dom';
import {Tooltip} from "@mui/material";

const LoginForPermitRegistration = () => {
    const georgianLettersRegex = /^[ა-ჰ]+$/;
    const [UserName, setUsername] = useState("");
    const [forgotEmail, setForgotEmail] = useState("");
    const [forgotEmailError, setForgotEmailError] = useState("");
    const [Password, setPassword] = useState("");
    const [active, setActive] = useState(false);
    const [showLoginPage, setShowLoginPage] = useState(true);
    const [showRegistration, setShowRegistration] = useState(false);
    const [showForgotPassword, setShowForgotPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const loginButtonRef = useRef(null);
    const [loginButtonDisabled, setLoginButtonDisabled] = useState(false);
    const navigate = useNavigate();
    const [isConditionPopupOpen, setIsConditionPopupOpen] = useState(false);
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [alert, setAlert] = useState({message: '', type: '', show: false});
    const [isLegalEntity, setIsLegalEntity] = useState(false);
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const returnUrl = searchParams.get('returnUrl');
    const parentId = searchParams.get('parentId');
    const objects = searchParams.get('objects');
    const entity = searchParams.get('entity');
    const explanationEntity = searchParams.get('explanationEntity');

    const toggleConditionPopup = () => {
        setIsConditionPopupOpen(!isConditionPopupOpen);
    };


    const jwtDecode = (token) => {
        try {
            const base64Url = token.split('.')[1];
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));

            return JSON.parse(jsonPayload);
        } catch (e) {
            return null;
        }
    };



    const handleLogin = async () => {

        try {
            setLoading(true);
            const params = new URLSearchParams({
                Email: UserName,
                Password: Password,
            });

            const apiUrl = process.env.REACT_APP_API_BASE_URL + "/User/Login";

            const response = await axios.get(`${apiUrl}?${params.toString()}`);

            if (response.status === 200 && response.data.success) {
                const token = response.data.data.token;
                const ExpiredTime = response.data.data.expirtaion;
                localStorage.setItem("jwtToken", token);
                localStorage.setItem("jwtTokenMain", token);
                localStorage.setItem("tokenExpiredTime", ExpiredTime);

                const decodedToken = jwtDecode(token);
                const userRole = decodedToken.role;

                try {
                    if (userRole && userRole !== "USER" && userRole !== "ROOTADMIN") {
                        const usersResponse = await axios.get(
                            `${process.env.REACT_APP_API_BASE_URL}/GetMyTemporaryUsers`
                        );

                        if (usersResponse.status === 200 && usersResponse.data.success) {
                            const temporaryUsers = usersResponse.data.data;

                            for (let index = 0; index < temporaryUsers.length; index++) {
                                const user = temporaryUsers[index];
                                const tempParams = new URLSearchParams({
                                    Email: user.onVacationUserEmail,
                                    Password: Password,
                                });

                                const tempLoginResponse = await axios.get(
                                    `${apiUrl}?${tempParams.toString()}`
                                );

                                if (
                                    tempLoginResponse.status === 200 &&
                                    tempLoginResponse.data.success
                                ) {
                                    const tempToken = tempLoginResponse.data.data.token;
                                    localStorage.setItem(`${index + 1}_jwtToken`, tempToken);
                                } else {
                                }
                            }
                        }
                    }
                } catch (error) {
                }


                if (userRole === "USER" && returnUrl) {
                    navigate(`/dashboard/newcase?id=${returnUrl}&parentId=${parentId}&entity=${entity}&explanationEntity=${explanationEntity}`);
                } else if (userRole === "ROOTADMIN") {
                    navigate("/dashboard/pagemanager");
                }
                else if (userRole !== "USER" && objects) {
                    navigate("/oldObjects");
                }
                else {
                    navigate("/dashboard/home");
                }
            } else {
                setAlert({
                    message: response.data.errors
                        ? response.data.errors[0].message
                        : "დაფიქსრიდა შეცდომა, ცადეთ მოგვიანებით",
                    type: "error",
                    show: true,
                });
            }
        } catch (error) {
            setAlert({
                message: "დაფიქსრიდა შეცდომა, ცადეთ მოგვიანებით",
                type: "error",
                show: true,
            });
        } finally {
            setLoading(false);
            setLoginButtonDisabled(false);
        }
    };


    const validateForgotEmail = () => {
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

        if (forgotEmail.trim() === "") {
            setForgotEmailError("აუცილებელი ველი");
            return false;
        } else if (!emailRegex.test(forgotEmail)) {
            setForgotEmailError("არასწორი ფორმატი");
            return false;
        } else {
            setForgotEmailError("");
            return true;
        }
    };


    const registrationValidationSchema = yup.object({
        UserName: yup.string()
            .required('გთხოვთ, შეიყვანოთ მომხამრებლის სახელი')
            .matches(/^[A-Za-z0-9#$%^&*]+$/, 'არასწორი ფორმატი')
            .min(3, 'ველი უნდა შეიცავდეს 3 სიმბოლოს'),
        Password: yup.string()
            .required('გთხოვთ, შეიყვანოთ პაროლი')
            .min(6, 'პაროლი უნდა შეიცავდეს მინიმუმ 6 სიმბოლოს')
            .matches(
                /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])/,
                'პაროლი უნდა შეიცავდეს ციფრს, დიდ ასოს და პატარა ასოს'
            ),
        ConfirmPassword: yup.string()
            .oneOf([yup.ref('Password'), null], 'პაროლები უნდა ემთხვეოდეს')
            .required('გთხოვთ განმეორებით შეიყვანოთ პაროლი'),
        PersonalNumber: yup.string()
            .matches(/^\d{11}$/, 'არასწორი ფორმატი')
            .required('გთხოვთ, შეიყვანოთ პირადი ნომერი'),
        FirstName: yup.string()
            .matches(georgianLettersRegex, 'სახელი უნდა შეიცავდეს მხოლოდ ქართულ ასოებს')
            .required('გთხოვთ, შეიყვანოთ სახელი'),
        LastName: yup.string()
            .matches(georgianLettersRegex, 'გვარი უნდა შეიცავდეს უნდა შეიცავდეს მხოლოდ ქართულ ასოებს')
            .required('გთხოვთ, შეიყვანოთ გვარი'),
        Email: yup.string().email('არასწორი ფორმატი').required('გთხოვთ, შეიყვანოთ ელ-ფოსტა'),
        Phone: yup.string().required('გთხოვთ შეიყვანოთ ნომერი'),
        termsAccepted: yup.boolean().oneOf([true], 'რეგისტრაციისთვის დაეთანხმეთ პირობებს'),
    });


    const orgNameSchema = yup.string()
        .required('გთხოვთ შეიყვანოთ ორგანიზაციის სახელი')

    const orgNumberSchema = yup.string()
        .required('გთხოვთ შეიყვანოთ ორგანიზაციის ნომერი')
        .matches(/^\d{11}$/, 'არასწორი ფორმატი')
        .length(11, 'არასწორი ფორმატი');


    const formik = useFormik({

        initialValues: {
            UserName: '',
            Password: '',
            ConfirmPassword: '',
            PersonalNumber: '',
            FirstName: '',
            LastName: '',
            Email: '',
            Phone: '',
            Mobile: '',
            termsAccepted: false,


            // Add other initial values if needed
        },
        validationSchema: registrationValidationSchema,
        validate: values => {
            const errors = {};
            if (isLegalEntity) {
                try {
                    orgNameSchema.validateSync(values.orgName);
                } catch (error) {
                    errors.orgName = error.message;
                }

                try {
                    orgNumberSchema.validateSync(values.orgNumber);
                } catch (error) {
                    errors.orgNumber = error.message;
                }
            }
            return errors;
        },
        onSubmit: async (values) => {
            try {
                const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/User/Registration`, {
                    username: values.UserName,
                    password: values.Password,
                    email: values.Email,
                    pNumber: values.PersonalNumber,
                    firstName: values.FirstName,
                    lastName: values.LastName,
                    phone: values.Phone
                });


                if (response.status === 200) {
                    if (response.data.success) {
                        setAlert({message: 'ოპერაცია წარმატებით დასრულდა!', type: 'success', show: true});
                        formik.resetForm();
                        handleLoginClick();
                    } else {
                        setAlert({
                            message: response.data.errorMessage || 'დაფიქსრიდა შეცდომა, ცადეთ მოგვიანებით',
                            type: 'error',
                            show: true
                        });
                    }
                } else {
                    setAlert({message: 'დაფიქსრიდა შეცდომა, ცადეთ მოგვიანებით', type: 'error', show: true});
                }
            } catch (error) {
                // Handle error
                setAlert({
                    message: error.message || 'დაფიქსრიდა შეცდომა, ცადეთ მოგვიანებით',
                    type: 'error',
                    show: true
                });
            }
        }
    });


    const handleLoginClick = () => {
        setShowLoginPage(true);
        setShowRegistration(false);
        setShowForgotPassword(false);
        setLoginButtonDisabled(false);
    };

    const handleRegistrationClick = () => {
        setShowLoginPage(false);
        setShowRegistration(true);
        setShowForgotPassword(false);
        setLoginButtonDisabled(false);
    };

    const handleForgotPasswordClick = () => {
        setShowLoginPage(false);
        setShowRegistration(false);
        setShowForgotPassword(true);
        setLoginButtonDisabled(false);
    };


    const handleForgotPasswordSubmit = () => {
        if (!validateForgotEmail()) {

        }
    };


    return (
        <div className="login-main-page">
            {showLoginPage && (
                    <div className="popup-login-permit">

                        <div>
                            <img src={herb} alt="Logo" className="popup-logo"/>
                            <h1 className="popup-title">{("შესვლა")}</h1>
                            <p className="popup-subtitle">
                                {("სააგენტოს ციფრული პორტალი")}
                            </p>
                            <p className="popup-text-block">{("შეიყვანე მონაცემები")}</p>
                            <input
                                type="text"
                                className="popup-input"
                                placeholder={("მომხმარებლის სახელი")}
                                value={UserName}
                                onChange={(e) => setUsername(e.target.value)}
                                onKeyDown={(e) => e.key === "Enter" && handleLogin()}
                            />
                            <div className="password-input-container">
                                <input
                                    type={passwordVisible ? "text" : "password"}
                                    className="popup-input-passworf"
                                    placeholder={"პაროლი"}
                                    value={Password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                                <button
                                    onClick={() => setPasswordVisible(!passwordVisible)}
                                    className="toggle-password-visibility"
                                >
                                    {passwordVisible ?
                                        <AiFillEyeInvisible style={{fontSize: '26px', color: '#2A2A2A'}}/> :
                                        <AiFillEye style={{fontSize: '26px', color: '#2A2A2A'}}/>}
                                </button>
                            </div>
                            <Tooltip
                                title={(Password === "" || UserName === "") ? "ავტორიზაციისთვის შეიყვანეთ ელ-ფოსტა და პაროლი" : ""}>
                            <div>
                                <button
                                    style={{marginBottom: 50}}
                                    className="popup-login-button"
                                    onClick={handleLogin}
                                    disabled={
                                        loading ||
                                        loginButtonDisabled ||
                                        Password === "" ||
                                        UserName === ""
                                    }
                                    ref={loginButtonRef}
                                >
                                    {loading ? "მიმდინარეობს ავტორიზაცია..." : "პორტალში შესვლა"}
                                </button>
                            </div>
                            </Tooltip>
                        </div>
                    </div>
            )}
            {showRegistration && (
                <div className={`popup-containerr ${active ? "active" : ""}`}>
                    <div className="popup-forget-permit">

                        <div>
                            <img src={herb} alt="Logo" className="popup-logo"/>
                            <h1 className="popup-title">{("რეგისტრაცია")}</h1>
                            <p className="popup-subtitle">
                                {("სააგენტოს ციფრული პორტალი")}
                            </p>
                            <div className={"popup-login-switcher"}>
                                <button className={`popup-text-blockk ${!isLegalEntity ? "active" : ""}`}
                                        onClick={() => setIsLegalEntity(false)}>
                                    {("ფიზიკური პირი")}
                                </button>
                                <button className={`popup-text-blockk ${isLegalEntity ? "active" : ""}`}
                                        onClick={() => setIsLegalEntity(true)}>
                                    {("იურიდიული პირი")}
                                </button>
                            </div>
                            <form className={"popup-registrtation-form"} onSubmit={formik.handleSubmit}>

                                <div className="input-container">
                                    <input
                                        type="text"
                                        name="UserName"
                                        placeholder={"მომხმარებლის სახელი"}

                                        className={`popup-input-registration ${formik.touched.UserName && formik.errors.UserName ? "input-error" : ""}`}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.UserName}
                                    />
                                    {formik.touched.UserName && formik.errors.UserName &&
                                        <div className="error-message-reg">{formik.errors.UserName}</div>}
                                </div>
                                <div className="input-container">
                                    <input
                                        type="text"
                                        name="PersonalNumber"
                                        placeholder={"პირადი ნომერი"}
                                        className={`popup-input-registration ${formik.touched.PersonalNumber && formik.errors.PersonalNumber ? "input-error" : ""}`}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.PersonalNumber}
                                    />
                                    {formik.touched.PersonalNumber && formik.errors.PersonalNumber &&
                                        <div className="error-message-reg">{formik.errors.PersonalNumber}</div>}
                                </div>

                                <div className="input-container">
                                    <input
                                        type="password"
                                        name="Password"
                                        placeholder={"პაროლი"}
                                        className={`popup-input-registration ${formik.touched.Password && formik.errors.Password ? "input-error" : ""}`}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.Password}
                                    />
                                    {formik.touched.Password && formik.errors.Password &&
                                        <div className="error-message-reg">{formik.errors.Password}</div>}
                                </div>

                                <div className="input-container">
                                    <input
                                        type="password"
                                        name="ConfirmPassword"
                                        placeholder={"გაიმეორეთ პაროლი"}
                                        className={`popup-input-registration ${formik.touched.ConfirmPassword && formik.errors.ConfirmPassword ? "input-error" : ""}`}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.ConfirmPassword}
                                    />
                                    {formik.touched.ConfirmPassword && formik.errors.ConfirmPassword &&
                                        <div className="error-message-reg">{formik.errors.ConfirmPassword}</div>}
                                </div>


                                <div className="input-container">
                                    <input
                                        type="text"
                                        name="FirstName"
                                        placeholder={"სახელი"}
                                        className={`popup-input-registration ${formik.touched.FirstName && formik.errors.FirstName ? "input-error" : ""}`}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.FirstName}
                                    />
                                    {formik.touched.FirstName && formik.errors.FirstName &&
                                        <div className="error-message-reg">{formik.errors.FirstName}</div>}
                                </div>

                                <div className="input-container">
                                    <input
                                        type="text"
                                        name="LastName"
                                        placeholder={"გვარი"}
                                        className={`popup-input-registration ${formik.touched.LastName && formik.errors.LastName ? "input-error" : ""}`}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.LastName}
                                    />
                                    {formik.touched.LastName && formik.errors.LastName &&
                                        <div className="error-message-reg">{formik.errors.LastName}</div>}
                                </div>

                                <div className="input-container">
                                    <input
                                        type="email"
                                        name="Email"
                                        placeholder={"ელ-ფოსტა"}
                                        className={`popup-input-registration ${formik.touched.Email && formik.errors.Email ? "input-error" : ""}`}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.Email}
                                    />
                                    {formik.touched.Email && formik.errors.Email &&
                                        <div className="error-message-reg">{formik.errors.Email}</div>}
                                </div>

                                <div className="input-container">
                                    <input
                                        type="text"
                                        name="Phone"
                                        placeholder={"ტელეფონი (მობილური / სახლის)"}
                                        className={`popup-input-registration ${formik.touched.Phone && formik.errors.Phone ? "input-error" : ""}`}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.Phone}
                                    />
                                    {formik.touched.Phone && formik.errors.Phone &&
                                        <div className="error-message-reg">{formik.errors.Phone}</div>}
                                </div>
                                {isLegalEntity && (
                                    <div className="input-container">
                                        <input
                                            type="orgName"
                                            name="orgName"
                                            placeholder={"ორგანიზაციის სახელი"}
                                            className={`popup-input-registration ${formik.touched.orgName && formik.errors.orgName ? "input-error" : ""}`}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.orgName}
                                        />
                                        {formik.touched.orgName && formik.errors.orgName &&
                                            <div className="error-message-reg">{formik.errors.orgName}</div>}
                                    </div>


                                )}
                                {isLegalEntity && (
                                    <div className="input-container">
                                        <input
                                            type="orgNumber"
                                            name="orgNumber"
                                            placeholder={"ორგანიზაციის საიდენტიფიკაციო კოდი"}
                                            className={`popup-input-registration ${formik.touched.orgNumber && formik.errors.orgNumber ? "input-error" : ""}`}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.orgNumber}
                                        />
                                        {formik.touched.orgNumber && formik.errors.orgNumber &&
                                            <div className="error-message-reg">{formik.errors.orgNumber}</div>}
                                    </div>
                                )}
                                <div className="checkbox-button-container">
                                    <div className="input-container">
                                        <input
                                            type="checkbox"
                                            name="termsAccepted"
                                            checked={formik.values.termsAccepted}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            className={formik.touched.termsAccepted && formik.errors.termsAccepted ? "input-error" : ""}
                                        />
                                        <label className={"agree-text"} htmlFor="termsAccepted">ვეთანხმები
                                            პირობებს</label>
                                        {formik.touched.termsAccepted && formik.errors.termsAccepted &&
                                            <div className="error-message-reg">{formik.errors.termsAccepted}</div>}

                                    </div>
                                    {formik.touched.termsAccepted && formik.errors.termsAccepted &&
                                        <div className="error-message-reg">{formik.errors.termsAccepted}</div>}
                                    <div>
                                        <div
                                            className="open-condition-popup-button"
                                            onClick={toggleConditionPopup}
                                        >
                                            პირობების ნახვა
                                        </div>
                                    </div>
                                </div>


                                <div>

                                    <button className={"reg-button-popup"} type="submit">რეგისტრაცია</button>
                                </div>
                            </form>


                            {isConditionPopupOpen && (
                                <ConditionPopup
                                    title={"წესები და პირობები"}
                                    onClose={toggleConditionPopup}/>
                            )}
                            <div className="popup-bottom-text">
                                <button
                                    className="popup-registration"
                                    onClick={handleLoginClick}
                                >
                                    <IoArrowBackSharp/> {("ავტორიზაციის გვერდზე დაბრუნება")}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showForgotPassword && (
                <div className={`popup-containerr ${active ? "active" : ""}`}>
                    <div className="popup-forget-permit">

                        <div>
                            <img src={herb} alt="Logo" className="popup-logo"/>
                            <h1 className="popup-title">{("დაგავიწყდა პაროლი?")}</h1>
                            <p className="popup-subtitle">
                                {("სააგენტოს ციფრული პორტალი")}
                            </p>
                            <input
                                type="text"
                                className="popup-input"
                                placeholder={("ელ.ფოსტა")}
                                value={forgotEmail}
                                onChange={(e) => setForgotEmail(e.target.value)}
                            />
                            {forgotEmailError && (
                                <p className="error-message-reg">{forgotEmailError}</p>
                            )}
                            <div>

                                <button
                                    className="popup-login-button"
                                    onClick={handleForgotPasswordSubmit}
                                >
                                    {("პაროლის აღდგენა")}
                                </button>
                            </div>

                            <div className="popup-bottom-text">
                                <button
                                    className="popup-registration"
                                    onClick={handleLoginClick}
                                >
                                    {("ავტორიზაციის გვერდზე დაბრუნება")}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            )}
            {alert.show && (
                <CustomAlert
                    message={alert.message}
                    type={alert.type}
                    onClose={() => setAlert({...alert, show: false})}
                />
            )}
        </div>
    )
};

export default LoginForPermitRegistration;
